import React from 'react';

/** The slanted section tab used across the operations reports. */
const SectionTitle = ({ id, children, tone = 'gold', note }) => (
  <div className="flex flex-wrap items-center gap-4">
    <h2
      id={id}
      className={`m-0 text-white text-base font-semibold py-2.5 pl-8 pr-14 ${
        tone === 'gold' ? 'bg-[#D4B95E]' : 'bg-[#1E4C56]'
      }`}
      style={{ clipPath: 'polygon(0 0, 100% 0, 88% 100%, 0 100%)' }}
    >
      {children}
    </h2>
    {note && <span className="text-sm text-gray-600">{note}</span>}
  </div>
);

export default SectionTitle;
